module.exports = __webpack_public_path__ + "img/theroom_guitars.cb457c68.jpg";